/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { PbCalculatedStructureDto } from '@gh/builder-shared-data';
import { ID } from '@gh/common-shared-data';

export type PbComponentItemFinderCcListItem = {
  costCenterId: ID;
  code: number;
  name: string;
  items: PbComponentItemFinderListItem[];
};
export type PbComponentItemFinderListItem = PbCalculatedStructureDto & { uniqueId: ID; costCenterCode: string; quantity?: number, count?: number };

export const getPbCcFinderListItemId = (cc: PbComponentItemFinderCcListItem) => cc.costCenterId;
export const getPbComponentItemFinderListItemId = (item: PbComponentItemFinderListItem) => item.uniqueId;

export const isPbStructureSuitable = ({ code, name }: PbComponentItemFinderListItem, filter: RegExp) =>
  filter.test(code) || filter.test(name);

export const pbFinderCcFromDto = (cc: PbComponentItemFinderCcListItem) => ({
  ...cc,
  items: (cc.items || []).map((item) => ({
    ...item,
    uniqueId: `${item.costCenterId}:${item.itemId}`,
    costCenterCode: cc.code,
  })),
});
